import React from 'react';
import { useIsMobile } from '@/hooks/use-mobile';
import { ProjectGraphData, Project } from '@/types/project';
import ProjectAnalyticsDesktop from './ProjectAnalyticsDesktop';
import ProjectAnalyticsMobile from './ProjectAnalyticsMobile';

export interface ProjectAnalyticsProps {
  graphData: ProjectGraphData | null;
  projectId: string;
  project: Project | null;
  loading?: boolean;
}

const ProjectAnalytics: React.FC<ProjectAnalyticsProps> = (props) => {
  const isMobile = useIsMobile();

  if (isMobile) {
    return <ProjectAnalyticsMobile {...props} />;
  }

  return <ProjectAnalyticsDesktop {...props} />;
};

export default ProjectAnalytics;
